import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy, OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { Result } from '../../results/result/result';
import { RemoteResultsService } from '../../results/remote-results.service';
import { environment } from '../../../../environments/environment';
import { AppService } from '../../../app.service';
import { RaceStandingsService } from '../../standings/race-standings.service';
import { ResultsMetaService } from '../../results/results-meta/results-meta.service';
import { RaceStanding } from '../race-standing';
import { RaceRanking } from '../race-ranking/race-ranking';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mc-race-ranking-standings',
  templateUrl: './race-ranking-standings.component.html',
  styleUrls: ['./race-ranking-standings.component.scss']
})
export class RaceRankingStandingsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() raceRanking: RaceRanking;

  @Output() save = new EventEmitter<Result>();

  rowDetailsOpen = {};
  isAdmin = !!environment.isAdmin;
  isModerable = false;
  isLoading = true; // @TODO

  constructor(
    private readonly appService: AppService,
    private readonly standingsService: RaceStandingsService,
    private readonly remoteResultsService: RemoteResultsService,
    private readonly resultsMetaService: ResultsMetaService
  ) {
  }

  ngOnInit() {
    console.log('RaceRankingStandings component init');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.raceRanking && changes.raceRanking.currentValue) {
      this.isModerable = !!environment.isAdmin && !!this.raceRanking.race.racePlan.resultsCouchDbName;
      // this.standingsService.recalculateStandingsSeasonPoints(this.rankingStandings, this.rankingRaceStagesRecord.seasonPointsMultiplier);
    }
  }

  trackResult(index: number, result: Result) {
    return result.createdAt;
  }

  trackRaceStanding(index: number, raceStanding: RaceStanding) {
    return raceStanding.driver.startNumber;
  }

  trackRaceStageStanding(index: number, _raceStageStanding: any) {
    return _raceStageStanding.key;
  }

  isActionUsed(action: string) {
    return this[action].observers.length > 0;
  }

  toggleVerification(result) {
    if (result.verification === null) {
      this.rejectResult(result);
      this.save.emit(result);
    } else if (result.verification === false) {
      this.restoreResult(result);
      this.save.emit(result);
    } else if (result.verification === true) {
      this.unverifyResult(result);
      this.save.emit(result);
    }
    setTimeout(() => this.unhoverResult(result), 500);
    // this.changed.emit(this.result);
  }

  saveResult(result: Result): Subscription {
    if (!!this.raceRanking?.race?.syncedStorage) {
      return this.raceRanking.race.syncedStorage.save$(result).subscribe();
    } else {
      throw new Error('No synced storage configured for the race.');
    }
    // return this.db.put(result)
    //   .then(updatedResult => {
    //     console.log('Result #' + result._id + ' successfully saved.');
    //     return this.db.get(result._id);
    //   })
    //   .catch(error => {
    //     console.error('Result save error', error, result);
    //   });
  }

  verifyResult(result: Result, isValid: boolean | null) {
    result.verification = isValid;
    return this.saveResult(result);
  }

  restoreResult(result: Result) {
    return this.verifyResult(result, true);
  }

  rejectResult(result: Result) {
    return this.verifyResult(result, false);
  }

  unverifyResult(result: Result) {
    return this.verifyResult(result, null);
  }

  toggleRowDetails(startNumber: number) {
    this.rowDetailsOpen[startNumber] = !this.rowDetailsOpen[startNumber];
    this.appService.fixView();
  }

  hoverResult(result: Result) {
    this.resultsMetaService.hover(result);
  }

  unhoverResult(result: Result) {
    this.resultsMetaService.unhover(result);
  }

  ngOnDestroy() {
  }
}
